import React from 'react';
import {CCol, CContainer, CFooter, CHeader, CHeaderBrand, CImg, CRow} from "@coreui/react";
import { matchPath, useLocation } from 'react-router-dom';
import logo from '../assets/images/glympse-pro-white.png';
import "../scss/public-layout.scss";
import RotatingBackground from "../shared/components/RotatingBackground";

const GLYMPSEPRO_SITE = 'https://glympsepro.com/';
const BASE_URL = '/';

interface LayoutProps {
  children: React.ReactNode;
}

const PublicLayout = (props: LayoutProps) => {
  const { children } = props;
  const imgElRef = React.useRef();
  const location = useLocation();
  const match = matchPath(location.pathname, '/login');
  const headerUrl = match ? GLYMPSEPRO_SITE : BASE_URL;
  return (
    <div className="c-app public-layout">
      <div className="c-wrapper">
        <CHeader>
          <CContainer fluid className="flex-center">
            <CHeaderBrand href={headerUrl} >
              <CImg src={logo} height={40} alt="Logo"/>
            </CHeaderBrand>
          </CContainer>
        </CHeader>
        <div className="c-body">
          <CContainer fluid className="p-0 h-100">
            <CRow className="h-100">
              <CCol className="overflow-auto p-5">
                {children}
              </CCol>
              <CCol innerRef={imgElRef} className="d-none d-md-block">
                <RotatingBackground elRef={imgElRef} />
              </CCol>
            </CRow>
          </CContainer>
        </div>
        <CFooter className="flex-center">
          © 2026 Copyright. All Rights Reserved. Made by Glympse Inc.
        </CFooter>
      </div>
    </div>
  );
};

export default PublicLayout;
